import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { GenericRepository } from "src/app/repositories/generic-repository/GenericRepository";
import { DashboardStats } from "../../../models/Production/dashboard";
import { IProductionDashboardRepository } from "./IProductionDashboardRepository";
import { ResponseModel } from "src/app/models/SharedModels/response.model";

@Injectable({
  providedIn: 'root'
})
export class ProductionDashboardRepository
  extends GenericRepository<DashboardStats>
  implements IProductionDashboardRepository {

  constructor(protected _http: HttpClient) {
    super(_http, 'api/productionDashboard', environment.urlAddress);
  }

  GetDashboardData(): Observable<ResponseModel> {
    const url = `/GetDashboardData`;
    return this.GetById(url)
      .pipe(map(this.extractData), catchError(this.handleError));
  }
}